import { createContext, useContext, useMemo } from "react"
import { Country } from "@/types/__generated__/union-types"

interface PatientParamContextValue {
  country: Country
  patientId: string
  appointmentId: string | null
}

const PatientParamContext = createContext<PatientParamContextValue | null>(null)

type PatientParamProviderProps = React.PropsWithChildren<{
  country: Country
  patientId: string
  appointmentId: string | null
}>

export const PatientParamProvider = ({ children, country, patientId, appointmentId }: PatientParamProviderProps) => {
  const value = useMemo(
    () => ({
      country,
      patientId,
      appointmentId,
    }),
    [country, patientId, appointmentId],
  )

  return <PatientParamContext.Provider value={value}>{children}</PatientParamContext.Provider>
}

export function usePatientParamContext(): PatientParamContextValue {
  const context = useContext(PatientParamContext)
  if (!context) throw new Error("Missing PatientParamProvider in the tree")
  return context
}
